import type { Section } from '@common/formEngine/formEngine.types';
import { type CustomControlCode } from '@common/enums';
import { pdfExtensions } from '@common/utils/fileExtensions';
import { getProcessActivityAssetsSchema } from '@common/validation/processActivityAsset';
import type { HolterRequest } from './hollterRequestsSchemas';
import type { HolterConsultRequestBase } from './holterConsultRequestSchemas';
import { getServiceOrganizationProviderSchema } from '../../serviceOrganizationProvider';
import {
    adviceQuestionSection,
    diagnosisSection,
    holterRiskFactorsSection,
    professionalSummarySection,
} from './holterConsultRequestSchemas';

export type HolterFollowUpConsultRequestData = HolterConsultRequestBase;

export const referralSection: Section<
    HolterFollowUpConsultRequestData,
    undefined,
    CustomControlCode.HolterFollowUpConsultRequest
> = {
    fields: [
        {
            draftSchema: getServiceOrganizationProviderSchema(true),
            finalSchema: getServiceOrganizationProviderSchema(),
            initialValue: {
                organizationId: null,
                practitionerId: null,
            },
            key: 'recipient',
            label: 'Verstuur naar',
            type: 'custom',
        },
    ],
};

export const examinationSection: Section<HolterConsultRequestBase, undefined, HolterRequest> = {
    fields: [
        {
            acceptExtensions: pdfExtensions,
            draftSchema: getProcessActivityAssetsSchema(),
            finalSchema: getProcessActivityAssetsSchema(),
            key: 'assets',
            label: 'Onderzoek',
            type: 'assets',
        },
    ],
    title: 'Onderzoek',
};

export const holterFollowUpConsultRequestSections: Section<
    HolterFollowUpConsultRequestData,
    undefined,
    HolterRequest
>[] = [
    referralSection,
    adviceQuestionSection,
    examinationSection,
    holterRiskFactorsSection,
    professionalSummarySection,
    diagnosisSection,
];
